var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhonenosvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.892578,
    y: 0.643326,
    width: 47.7429,
    height: 47.7429,
    rx: 3.97858,
    fill: "#FEF0EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.01 28.38C31.78 28.38 30.59 28.18 29.48 27.82C29.3061 27.7614 29.1192 27.7528 28.9406 27.7953C28.762 27.8377 28.599 27.9294 28.47 28.06L26.9 30.03C24.07 28.68 21.42 26.13 20.01 23.2L21.96 21.54C22.23 21.26 22.31 20.87 22.2 20.52C21.83 19.41 21.64 18.22 21.64 16.99C21.64 16.45 21.19 16 20.65 16H17.19C16.65 16 16 16.24 16 16.99C16 26.28 23.73 34 33.01 34C33.72 34 34 33.37 34 32.82V29.37C34 28.83 33.55 28.38 33.01 28.38Z",
    fill: "#F46530"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonenosvg);
export default __webpack_public_path__ + "static/media/phonenosvg.15d4c6a5762cdd960be328eda8e24270.svg";
export { ForwardRef as ReactComponent };